import { db } from "./FirebaseService";
import { ref, push, onValue, update, serverTimestamp } from "firebase/database";
import { onMounted, onUnmounted, ref as vueRef } from 'vue'
import { getUid } from "./AuthService";
import { getThreadPath } from "./MessagesService";
import { useMessagesStore } from "@/stores/useMessagesStore";

const scheduledTime = vueRef({})

//Save contact information and send system message indicating contact captured
export function saveDateTime(dateString, timeString) {
    const uid = getUid();
    if (!uid) return;
    const chatId = useMessagesStore().ensureChatId();
    update(ref(db, `date_time/${uid}/`), {dateTime: `${dateString} at ${timeString}`, status: 'submitted'})
    const date = new Date()
    const string = date.toLocaleString('en-US', { weekday: 'long', month: 'long', day: '2-digit',  hour: 'numeric', minute: '2-digit', hour12: true })
    push(ref(db, getThreadPath(uid, chatId)), {
        role: 'system',
        content: `The current date and time is ${string}. The user's preferred date and time for a test drive is ${dateString} at ${timeString}.`,
        action: "test_drive_requested",
        timestamp: serverTimestamp(),
    })
}

//update contact information and send system message indicating contact captured
export function cancelDateTime() {
    const uid = getUid();
    if (!uid) return;
    const chatId = useMessagesStore().ensureChatId();
    update(ref(db, `date_time/${uid}/`), { status: 'skipped' })
    push(ref(db, getThreadPath(uid, chatId)), {
        role: 'system',
        content: `The user skipped scheduling a test drive.`,
        name: "test_drive_skipped",
        timestamp: serverTimestamp(),
    })
}

//Observe Contact information in database
export function observeDateTime() {
    let stopListening = null
    const uid = getUid();
    if (!uid) return;
    onMounted(() => {
        stopListening = onValue(ref(db, `date_time/${uid}/`), (data) => {
            if (data.exists()) {
                console.log(data.val())
                scheduledTime.value = data.val()
            } else {
                scheduledTime.value = { status: null }
            }
        })
    })

    onUnmounted(() => {
        if (stopListening)
            stopListening()
    })

    return scheduledTime
}